<template>
  <div class="app-main-inner app-main-page" style="height:auto">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('Partners.batchEditServer')"
      width="950px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row">
        <div class="filters" style="display: inline;width: 520px;">
          <el-form :inline="true" label-width="70px" label-position="left">
            <!--用户名称-->
            <el-form-item :label="$t('Partners.userName')">
              <cargo-advance-select
                no="userName"
                :select-type="selectTypeNames.basic_data_User"
                filterable
                :callback-params="{key:'companyUser'}"
                callback-method-type="value"
                :default-value="filter.companyUser"
                :fields="['chineseName']"
                options-width="230px"
                @parentCallBack="selectCargoItem"
              />
            </el-form-item>
            <!--合作伙伴-->
            <el-form-item :label="$t('baseInfo.partner.companyName')">
              <el-input v-model="filter.companyName" no="companyName" />
            </el-form-item>
            <!--业务类型-->
            <el-form-item :label="$t('Payment.businessType')">
              <el-select v-model="filter.lob" no="lob" multiple collapse-tags>
                <el-option
                  v-for="(item,index) in lobs"
                  :key="index"
                  :label="isZh ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <!--岗位类型-->
            <el-form-item :label="$t('Partners.positionType')">
              <el-select v-model="filter.roleType" no="roleType">
                <el-option :label="$t('CargoMsg.Cargo_AllP')" value="" />
                <el-option
                  v-for="(item,index) in roleTypes"
                  :key="index"
                  :label="isZh ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="triggers">
          <el-button no="toQuery" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>&nbsp;
          <el-button no="showEditDialog" type="primary" @click="showEditDialog">{{ $t('Partners.batchModifyServicePersonnel') }}</el-button>&nbsp;
          <el-button no="exportExcel" :disabled="total===0" type="primary" @click="exportExcel">{{ $t('Partners.exportModificationResults') }}</el-button>
        </div>
      </div>
      <div class="app-main-inner-row row-grid" style="min-height:350px;">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="app-main-inner-row row-pagination" style="padding-right:0px;">
        <cargo-pagination
          v-show="total>0"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </el-dialog>
    <!-- 编辑弹窗 -->
    <el-dialog
      id="app"
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('Partners.changeServicePersonnel')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row">
        <el-form :inline="true" label-width="70px" label-position="left">
          <el-form-item :label="$t('Partners.userName')">
            <cargo-advance-select
              no="companyUser"
              :select-type="selectTypeNames.basic_data_User"
              filterable
              :method-params="{active:true}"
              :callback-params="{key:'sales'}"
              callback-method-type="value"
              :default-value="editDialog.companyUser"
              :fields="['chineseName']"
              options-width="230px"
              @parentCallBack="changeDialogCompanyUser"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as CargoOfRoleTypeUtil from '@/class/cargo/model/utils/CargoOfRoleTypeUtil'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { searchUserForSales, updateUser } from '@/api/partner/companyUser'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { deepClone } from '@/utils'
import StrUtils from '@/utils/StrUtils'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'EditCompanyUser',
  components: { cargoAdvanceSelect, cargoUserSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    checkHQReadOnlyPermission: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      innerVisible: false,
      lobs: [],
      roleTypes: [],
      selectTypeNames: TYPE_NAMES,
      filter: {
        companyName: '',
        currentBranchId: '',
        branchId: '',
        roleType: '',
        companyUser: '',
        companyType: 'CUSTOMER',
        partnersApproved: 0,
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Partners.partnerAbbreviation'),
          field: 'cnShortName'
        },
        {
          headerName: this.$t('Partners.chineseNameOfPartner'),
          field: 'chineseName'
        },
        {
          headerName: this.$t('SeaExport.ChargeBranchId'),
          field: 'branchId',
          cellRenderer: params => {
            if (params.value === 1) {
              return 'HQ'
            }
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
            return value || params.value
          }
        },
        {
          headerName: this.$t('Partners.servicePersonal'),
          field: 'userId',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.businessType'),
          field: 'lob',
          cellRenderer: params => {
            return this.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Partners.positionType'),
          field: 'roleType',
          cellRenderer: params => {
            return this.roleTypeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Partners.isItSuccessful'),
          field: 'isSucceed'
        }
      ],
      rowData: [],
      gridApi: null,
      editDialog: {
        visible: false,
        title: '',
        companyUser: '',
        form: {
          companyUuidList: [],
          sales: '',
          tenantId: ''
        }
      }
    }
  },
  computed: {
    isZh() {
      return this.$i18n.locale === 'zh'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.filter = this.filterInit()
        this.rowData = []
      }
    }
  },
  async created() {
    this.lobs = SystemConstants.LOBS
    this.roleTypes = await CargoOfRoleTypeUtil.getRoleTypes()
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.onGridDateRendered()
    },
    async toQuery(callback) {
      if (!this.filter.companyUser) {
        this.$message.warning(this.$t('Partners.enterUserInformation'))
        return
      }
      const currentOffice = this.$store.getters.currentOffice
      this.filter.currentBranchId = currentOffice.officeId
      if (currentOffice.code !== 'HQ') {
        this.filter.branchId = currentOffice.officeId + ',1'
      }
      this.filter.partnersApproved = Number(cache.config.get('PartnersApproved'))
      const data = deepClone(this.filter)
      if (this.filter.lob) {
        data.lob = this.filter.lob.join(',')
      }
      await searchUserForSales(data).then(res => {
        if (callback && typeof callback === 'function') {
          callback(res.data.list)
        }
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
        this.onGridDateRendered()
      })
    },
    onGridDateRendered() {
      const columnApi = this.gridApi.columnController.columnApi
      const columnIds = []
      this.gridApi.columnController.gridColumns.forEach(p => {
        columnIds.push(p.colId)
      })
      setTimeout(() => {
        columnApi.autoSizeColumns(columnIds)
      })
    },
    changeDialogCompanyUser(item) {
      this.editDialog.companyUser = item.value
    },
    selectCargoItem(item) {
      this.filter[item.key] = item.value
    },
    showEditDialog() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const checkHQReadOnly = this.checkHQReadOnlyPermission(rows)
      if (!checkHQReadOnly) {
        return
      }
      this.editDialog.form = {
        companyUuidList: [],
        sales: '',
        tenantId: rows[0].tenantId
      }
      for (const item of rows) {
        this.editDialog.form.companyUuidList.push(item.uuid)
      }
      this.editDialog.companyUser = ''
      this.editDialog.visible = true
    },
    selectEditCargoItem(item) {
      this.editDialog.form[item.key] = item.value
    },
    save() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (!rows) {
        this.$message.info(this.$t('Partners.selectAUserToModify'))
        return
      }
      const obj = {}
      obj.userId = this.editDialog.companyUser
      obj.uuids = rows.map(row => row.uuid)
      obj.branchId = this.$store.getters.currentOfficeId
      if (Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1) {
        updateUser(obj).then(res => {
          // 局部数据更新
          for (const row of this.rowData) {
            if (obj.uuids.includes(row.uuid)) {
              row.userId = obj.userId
              row.isSucceed = '是'
            }
          }
          this.gridApi.refreshCells({ force: true })
          this.$emit('callback', obj.uuids)
          this.editDialog.visible = false
          this.$message.success(this.$t('common.tips.saveSuccess'))
        })
      }
    },
    filterInit() {
      return {
        companyName: '',
        currentBranchId: '',
        branchId: '',
        roleType: '',
        companyUser: '',
        companyType: 'CUSTOMER',
        partnersApproved: 0,
        pageNum: 1,
        pageSize: 50
      }
    },
    exportExcel() {
      let rows = this.gridOptions.api.getSelectedRows()
      rows = deepClone(rows)
      const fileName = this.$t('Partners.batchChangeSales') + new Date().getTime().toString() + '.xls'
      const tHeader = []
      const filterVal = []
      // 对行中每列的值做处理
      for (const item of rows) {
        if (!item) continue
        for (const colDef of this.columnDefs) {
          const dataField = colDef.field
          if (!colDef.headerName || !dataField) continue
          if (!tHeader.includes(colDef.headerName) && !filterVal.includes(dataField)) {
            tHeader.push(colDef.headerName)
            filterVal.push(dataField)
          }
          let data = item.hasOwnProperty(dataField) ? item[dataField] : ''
          // 进行labelFunction 处理
          if (colDef.cellRenderer && typeof colDef.cellRenderer !== 'string') {
            const params = { data: item, value: item[dataField] }
            params.colDef = { field: colDef.field }
            data = colDef.cellRenderer(params)
          }
          if (data && typeof data === 'string') {
            data = StrUtils.replaceSpecialCharacter(data)
          }
          item[dataField] = data
        }
      }
      import('@/vendor/Export2Excel').then(excel => {
        const data = this.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: fileName
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    jobBussStateLabelFunc(value) {
      const state = SystemConstants.getCommonState(value, SystemConstants.LOBS)
      if (state == null) {
        return this.isZh ? this.$t('SeaExport.All') : 'All'
      }
      return this.isZh ? state.chineseName : state.englishName
    },
    roleTypeLabelFunc(value) {
      const roleType = CargoOfRoleType.getCargoOfRoleTypeByCode(value)
      if (roleType) {
        return this.isZh ? roleType.chineseName : roleType.englishName
      }
      return ''
    }
  }
}
</script>

<style>
</style>
